import React, { FC, useEffect, useState } from "react";
import StatusMessage from "Shared/components/status-message";
import TextLink from "Shared/components/text-link";
import { StatusMessageType } from "Shared/util/custom-hooks";
import { PaymentInformationMessageTypeResource } from "Shared/util/types";
import { useGetMessageCodeTranslation } from "../hooks";
import {
    PayoutInformationStatusMessageProps,
    PayoutInformationStatusMessageState,
} from "../types";
import styles from "./styles/index.css";

export const PayoutInformationStatusMessage: FC<
    PayoutInformationStatusMessageProps
> = ({ bic, message }) => {
    const getMessageCodeTranslation = useGetMessageCodeTranslation();

    const [state, setState] = useState<PayoutInformationStatusMessageState>({
        link: null,
        linkText: null,
        text: null,
        type: "NONE",
    });

    useEffect(() => {
        if (!message) {
            setState({ link: null, linkText: null, text: null, type: "NONE" });
            return;
        }

        const { text, link, linkText } = getMessageCodeTranslation(
            bic,
            message.translationKey,
        );

        const type: StatusMessageType = !message
            ? "FAILED"
            : message.type === PaymentInformationMessageTypeResource.Error
            ? "FAILED"
            : "PENDING";

        setState({ link, linkText, text, type });
    }, [bic, getMessageCodeTranslation, message]);

    return (
        <StatusMessage
            className={styles.statusMessageContainer}
            hideButton
            status={state.type}
            text={
                <>
                    {state.text}
                    {state.link && state.linkText && (
                        <>
                            {" "}
                            <TextLink link={state.link} text={state.linkText} />
                        </>
                    )}
                </>
            }
        />
    );
};
